import React, { useState } from "react";
import Header from "../components/Header";
import Banner from "../components/banner";
import StatsSection from "../components/StatsSection";
import { Carousel } from "../components/carousel";
import carouselItems from "../components/CarouselItems";
import RollingGallery from "../components/RollingGallery";
import DeveloperCollaboration from "../components/Developers";
import YoutubeEmbedSimpleDuplicate from "../components/YoutubeEmbedSimpleDuplicate";
import Footer from "../components/Footer";
import TestimonialSection from "../components/Testimonial";
import UpcomingProjectsMap from "../components/UpcomingProjectsMap";
import PopupForm from "../components/PopupForm"; // ✅ Make sure this is correct

const Index = () => {
  const [showPopup, setShowPopup] = useState(false); // ✅ Popup state

  return (
    <div className="min-h-screen flex flex-col">
      <>
        <Header />
        <Banner />
        <StatsSection />
        <RollingGallery autoplay={true} pauseOnHover={true} />
        <Carousel items={carouselItems} />
        <UpcomingProjectsMap />
        <DeveloperCollaboration />
        <TestimonialSection />
        <YoutubeEmbedSimpleDuplicate />

        {/* CTA Section */}
        <section
          className="relative w-full h-[50vh] md:h-[60vh] bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url('assets/bridge.png')" }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative z-10 flex flex-col justify-center items-center h-full text-white text-center px-4">
            <h2 className="text-3xl md:text-5xl font-bold mb-4 leading-tight">
              Want to achieve outstanding sales for your new project?
            </h2>
            <p className="text-base md:text-xl font-semibold text-gray-200 max-w-2xl mb-10">
              Big Sales, Fast Deals, No Stress
            </p>
            <button
              onClick={() => setShowPopup(true)} // ✅ Opens the popup
              className="px-6 py-3 border border-white rounded-full font-semibold text-white hover:bg-white hover:text-black transition"
            >
              Enquire Now
            </button>
          </div>
        </section>

        {/* ✅ Render the popup when showPopup is true */}
        {showPopup && <PopupForm onClose={() => setShowPopup(false)} />}

        <Footer />
      </>
    </div>
  );
};

export default Index;
